module.exports = __webpack_public_path__ + "media/images/svg_losentimos-836b7763292b1295a221dbc0602823e3.svg";